import { BASE_URL, MOBILE_BASE_URL } from "../api_const"

export const DASHBOARD_BASE_URL = BASE_URL + "/dashboard/summery"
export const TOP_5_PROJECTS_URL = DASHBOARD_BASE_URL + "/top-project-size"
export const PROJECTS_SUMMARY_URL = DASHBOARD_BASE_URL + "/top-project-count"
export const TOP_PROJECTSBY_CATEGORY_URL = DASHBOARD_BASE_URL + "/project-category-size"

